module.exports = __webpack_public_path__ + "static/logo-84f03138ddf6d9f66c14e04569fb0892.png";